// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2X7I-","title":"ClientCherryInfo_title__1vbyS","itemText":"ClientCherryInfo_itemText__2d9C1"};